import * as React from 'react';
import { makeStyles, tokens, Card, CardHeader, mergeClasses, Caption1, Checkbox, Text, CardHeaderProps } from '@fluentui/react-components';

export interface CustomCardProps {
  icon: CardHeaderProps['image'];
  selected?: boolean;
  onSelectionChange?: (selected: boolean) => void;
  header: string;
  caption: string;
  actions?: React.ReactNode;
}

const useStyles = makeStyles({
  textOverflow: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },
  caption: {
    color: tokens.colorNeutralForeground3,
  },
  card: {
    maxWidth: '100%',
    height: 'fit-content',
  },
  heading: {
    color: tokens.colorNeutralForeground1,
  },
  cardHeader: {
    '& .fui-CardHeader__description,& .fui-CardHeader__header': {
      minWidth: 0,
    },
    '& .fui-CardHeader__description': {
      color: tokens.colorNeutralForeground3,
    },
  },
  actionButtons: {
    display: 'flex',
  },
});

export const CustomCard = ({ selected, onSelectionChange, header, caption, actions, icon }: CustomCardProps) => {
  const styles = useStyles();

  return (
    <Card
      selected={false} // Selection is only indicated by checkbox state
      className={styles.card}
      onSelectionChange={() => onSelectionChange?.(!selected)}
    >
      <CardHeader
        className={styles.cardHeader}
        image={icon}
        header={
          <Text
            title={header}
            className={mergeClasses(styles.heading, styles.textOverflow)}
          >
            {header}
          </Text>
        }
        description={
          <Caption1
            title={caption}
            className={mergeClasses(styles.caption, styles.textOverflow)}
          >
            {caption}
          </Caption1>
        }
        action={
          <div className={styles.actionButtons}>
            {typeof selected !== 'undefined' && (
              <Checkbox
                onChange={(_, data) => onSelectionChange?.(!!data.checked)}
                checked={selected}
              />
            )}
            {actions}
          </div>
        }
      />
    </Card>
  );
};
